module.exports = __webpack_public_path__ + "img/zh.f7875e4e.png";